module.exports = __webpack_public_path__ + "static/media/starbucks.f0c5574b.webp";